import { Card } from './Card';

type DeltaTone = 'pos' | 'neg' | 'flat';

interface Props {
  label: string;
  value: string | number;
  delta?: string;
  deltaTone?: DeltaTone;
}

const DELTA_COLOR: Record<DeltaTone, string> = {
  pos: 'var(--ok)',
  neg: 'var(--err)',
  flat: 'var(--text-3)',
};

export function KpiCard({ label, value, delta, deltaTone = 'flat' }: Props) {
  return (
    <Card pad={16}>
      <div className="text-[11.5px] uppercase tracking-[0.07em] font-semibold text-text-3 mb-1.5">
        {label}
      </div>
      <div className="text-[24px] font-semibold leading-tight -tracking-[0.02em] text-text">
        {value}
      </div>
      {delta && (
        <div className="mt-1.5 text-[11.5px]" style={{ color: DELTA_COLOR[deltaTone] }}>
          {delta}
        </div>
      )}
    </Card>
  );
}
